<template>
  <div class="home">
    <l-map
            ref="mainMap"
            id="mainMap"
            :zoom="zoom"
            :center="center"
            @update:zoom="zoomUpdated"
            @update:center="centerUpdated"
            @update:bounds="boundsUpdated"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <v-marker-cluster ref="clusterRef" :options="{maxClusterRadius: 50}"></v-marker-cluster>
    </l-map>
    <station-info v-if="showStation" v-model="station" @close="closeStation"/>
    <router-link to="/about"><m-fab :mini="true" :absolute-right="true" class="help-button"><template v-slot:icon><span class="fa fa-question"></span></template></m-fab></router-link>
    <div class="searchbox-container">
      <form class="searchbox" id="searchForm">
        <div>
          <input type="text" placeholder="Go to Postcode/Place Name">
        </div>
        <div class="searchbox-button-container">
          <button><span class="fa fa-search"></span></button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Leaflet from 'leaflet';
import 'leaflet.locatecontrol/dist/L.Control.Locate.min';
import StationInfo from "../components/StationInfo";
import * as L from "leaflet-extra-markers";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import { BingProvider } from 'leaflet-geosearch';
import Swal from 'sweetalert2'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
Vue.component('v-marker-cluster', Vue2LeafletMarkerCluster);

export default {
  components: {
    StationInfo: StationInfo
  },
  mounted () {
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test( userAgent );
    };

    localStorage.version = 15; //change API

    let thisThis = this;
    window.addEventListener('popstate', function(event) {
        thisThis.closeStation();
    });

    Vue.axios.get('/api/v1.0/version').then((response) => {
        console.log("This version: " + localStorage.version);
        console.log("Current version: " + response.data.data.version);
        if (response.data.data.version && response.data.data.version > localStorage.version) {
          console.log("Updating...");
          window.location.reload(true);
        }
    });

    // Detects if device is in standalone mode
    /*const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      if(!this.$cookies.get('pwaPrompt')){
        this.$cookies.set("pwaPrompt","true","1d");
        Swal.fire({
          title: 'Install AutogasApp',
          html: 'Install this webapp on iPhone.<br><br>Open in Safari (if not already), Tap <img src="/img/icons/share.jpg" width="25"> and then Add to homescreen.',
          type: 'info',
          confirmButtonText: 'Not now'
        });
      }
    }*/

    this.$nextTick(() => {
      let mapObject = this.$refs.mainMap.mapObject;
      let mapObjectCluster = this.$refs.clusterRef.mapObject;
      Leaflet.control.locate({
        keepCurrentZoomLevel: true
      }).addTo(mapObject);
      navigator.geolocation.getCurrentPosition(function(location) {
        let latLng = new Leaflet.LatLng(location.coords.latitude, location.coords.longitude);
        mapObject.setView(latLng, 12)
      });

      const form = document.querySelector('#searchForm');
      const input = form.querySelector('input[type="text"]');

      const provider = new BingProvider({
        params: {
          key: 'AkQdQ1qA2M406i6PyUVn8A--qQbVWIJxldaybA1sVrril0554mlluPmjkZiClMwm',
        },
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const results = await provider.search({ query: input.value });
        if(results[0]){
          let latLng = new Leaflet.LatLng(results[0].y, results[0].x);
          mapObject.setView(latLng, 12);
          input.setAttribute('readonly', 'readonly'); // Force keyboard to hide on input field.
          input.setAttribute('disabled', 'true'); // Force keyboard to hide on textarea field.
          setTimeout(function() {
            input.blur();
            input.removeAttribute('readonly');
            input.removeAttribute('disabled');
          }, 100);

        }else{
          form.className += ' search-error';
          setTimeout(function(){ form.classList.remove("search-error"); }, 1000);
        }
      });

      Vue.axios.get('/api/v1.0/stations').then((response) => {
        if(response.data.data){
          for (let i = 0; i < response.data.data.length; i++) {
            if(response.data.data[i].location) {
              let stationMarker = L.ExtraMarkers.icon({
                icon: 'fa-gas-pump',
                markerColor: 'blue',
                shape: 'square',
                prefix: 'fa'
              });

              if(response.data.data[i].price && response.data.data[i].price > 0){
                let markerColor = 'green';
                if(response.data.data[i].price >= 80){
                  markerColor = 'yellow';
                }
                if(response.data.data[i].price >= 90){
                  markerColor = 'red';
                }

                stationMarker = L.ExtraMarkers.icon({
                  icon: 'fa-number',
                  number: response.data.data[i].price,
                  markerColor: markerColor,
                  shape: 'square',
                  prefix: 'fa'
                });
              }

              if(response.data.data[i].price == 0.0){
                stationMarker = L.ExtraMarkers.icon({
                  icon: 'fa-times',
                  markerColor: 'orange-dark',
                  shape: 'square',
                  prefix: 'fa'
                });
              }

              Leaflet.marker([response.data.data[i].location.y, response.data.data[i].location.x], {icon: stationMarker}).addTo(mapObjectCluster).on('click', () => {


                  this.station = response.data.data[i];
                  history.pushState({key: this.station.identifier}, 'AutogasApp: '+this.station.name, '/station/'+this.station.identifier);

                  document.title = 'AutogasApp: '+this.station.name;
                  this.showStation = true;
                this.lastStationLatLng = new Leaflet.LatLng(response.data.data[i].location.y, response.data.data[i].location.x);
                // get pixels of marker on click
                let markerContainerPoint = mapObject.latLngToContainerPoint(new Leaflet.LatLng(response.data.data[i].location.y, response.data.data[i].location.x));

                // add the half the width of the available area
                let stationInfoWidth = window.innerWidth * 0.4; // station info is 40% width
                if (stationInfoWidth > 600) {
                  stationInfoWidth = 600; // max width
                }
                stationInfoWidth = stationInfoWidth + 250; // margin and space to right
                let availableArea = window.innerWidth - stationInfoWidth;

                markerContainerPoint.x = (markerContainerPoint.x + (availableArea / 2));

                // centre the lat lng at that point
                mapObject.setView(mapObject.containerPointToLatLng(markerContainerPoint));
              });
            }
          }
            if(this.$route.params.id){
                this.station = response.data.data.find(o => o.identifier === this.$route.params.id);
                history.pushState({key: this.station.identifier}, 'AutogasApp: '+this.station.name, '/station/'+this.station.identifier);
                document.title = 'AutogasApp: '+this.station.name;
                this.showStation = true;
                this.lastStationLatLng = new Leaflet.LatLng(this.station.location.y, this.station.location.x);
                // get pixels of marker on click
                let markerContainerPoint = mapObject.latLngToContainerPoint(new Leaflet.LatLng(this.station.location.y, this.station.location.x));

                // add the half the width of the available area
                let stationInfoWidth = window.innerWidth * 0.4; // station info is 40% width
                if (stationInfoWidth > 600) {
                    stationInfoWidth = 600; // max width
                }
                stationInfoWidth = stationInfoWidth + 250; // margin and space to right
                let availableArea = window.innerWidth - stationInfoWidth;

                markerContainerPoint.x = (markerContainerPoint.x + (availableArea / 2));

                // centre the lat lng at that point
                setTimeout(function(){
                    mapObject.setView(mapObject.containerPointToLatLng(markerContainerPoint));
                },200);
            }
        }
      });
    });
  },
  data () {
    return {
      url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 6,
      center: [54.68653, -3.14209],
      bounds: null,
      station: {
        active: false,
        connectors: [],
        opening_hours: [],
        payment_methods: [],
        priceUpdated: false,
        priceUpdating: false,
        price: null,
        price_last_updated_at: null
      },
      showStation: false,
      lastStationLatLng: null
    };
  },
  methods: {
    zoomUpdated (zoom) {
      this.zoom = zoom;
    },
    centerUpdated (center) {
      this.center = center;
    },
    boundsUpdated (bounds) {
      this.bounds = bounds;
    },
    closeStation () {
      this.showStation = false;
      let mapObject = this.$refs.mainMap.mapObject;
      mapObject.setView(this.lastStationLatLng);
    }
  }
};
</script>

<style>
  @import '~leaflet.locatecontrol/dist/L.Control.Locate.css';
  @import '~leaflet-extra-markers/src/assets/css/leaflet.extra-markers.css';
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  @import "~material-components-vue/dist/fab/fab.min.css";

  @media (min-width: 1024px) {
	  .help-button {
		  bottom: calc(1.5rem + env(safe-area-inset-bottom, 0)) !important;
		  right: calc(1.5rem + env(safe-area-inset-right, 0)) !important;
	  }
  }

  .help-button {
	  bottom: calc(1rem + env(safe-area-inset-bottom, 0)) !important;
	  right: calc(1rem + env(safe-area-inset-right, 0)) !important;
  }

  .leaflet-top {
	  top: env(safe-area-inset-top, 0) !important;
  }

  .leaflet-left {
	  left: env(safe-area-inset-left, 0) !important;
  }

  .leaflet-right {
	  right: env(safe-area-inset-right, 0) !important;
  }
</style>